"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SearchInput = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

/* Ported from https://outlookweb.visualstudio.com/Outlook%20Web */
var styles = require('./SearchBox.scoped.scss');

var SearchInput = /*#__PURE__*/function (_BaseComponent) {
  (0, _inherits2.default)(SearchInput, _BaseComponent);

  var _super = (0, _createSuper2.default)(SearchInput);

  function SearchInput() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, SearchInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.searchInput = void 0;

    _this._onClick = function (evt) {
      evt.stopPropagation();

      if (_this.props.setIsFocusInSearchInput !== undefined) {
        _this.props.setIsFocusInSearchInput(true
        /* isFocusInSearchInput */
        );
      }
    };

    _this._onFocus = function (_evt) {
      if (_this.props.onFocus !== undefined) {
        _this.props.onFocus();
      }

      if (_this.props.setIsFocusInSearchInput !== undefined) {
        _this.props.setIsFocusInSearchInput(true
        /* isFocusInSearchInput */
        );
      }
    };

    _this._onBlur = function (evt) {
      if (_this.props.setIsFocusInSearchInput !== undefined) {
        _this.props.setIsFocusInSearchInput(false
        /* isFocusInSearchInput */
        );
      }

      if (_this.props.onBlur !== undefined) {
        _this.props.onBlur(evt);
      }
    };

    _this._onSearchTextChange = function () {
      // Set the store value synchronously to prevent rendering issues
      if (_this.props.onSearchChange !== undefined) {
        var _this$searchInput$val, _this$searchInput;

        _this.props.onSearchChange((_this$searchInput$val = (_this$searchInput = _this.searchInput) === null || _this$searchInput === void 0 ? void 0 : _this$searchInput.value) !== null && _this$searchInput$val !== void 0 ? _this$searchInput$val : '');
      }

      if (_this.props.setSearchTextForSuggestion !== undefined) {
        var _this$searchInput$val2, _this$searchInput2;

        _this.props.setSearchTextForSuggestion((_this$searchInput$val2 = (_this$searchInput2 = _this.searchInput) === null || _this$searchInput2 === void 0 ? void 0 : _this$searchInput2.value) !== null && _this$searchInput$val2 !== void 0 ? _this$searchInput$val2 : '');
      }
    };

    return _this;
  }

  (0, _createClass2.default)(SearchInput, [{
    key: "setFocus",

    /**
     * Sets/puts focus on the search input
     */
    value: function setFocus() {
      var _this$searchInput3;

      (_this$searchInput3 = this.searchInput) === null || _this$searchInput3 === void 0 ? void 0 : _this$searchInput3.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      var _this$searchInput4;

      (_this$searchInput4 = this.searchInput) === null || _this$searchInput4 === void 0 ? void 0 : _this$searchInput4.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          searchText = _this$props.searchText,
          canShowPlaceholder = _this$props.canShowPlaceholder,
          searchPlaceholderText = _this$props.searchPlaceholderText; // We want to show place holder text only when there is not search text and no persona pill ids

      var shouldShowPlaceholder = (searchText === '' || searchText === undefined) && canShowPlaceholder !== false;
      var placeHolderToShow = shouldShowPlaceholder ? searchPlaceholderText : '';
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        ref: this._resolveRef('searchInput'),
        className: styles.searchBoxInput,
        disabled: this.props.disabled,
        "aria-label": searchPlaceholderText,
        placeholder: placeHolderToShow,
        value: searchText,
        onChange: this._onSearchTextChange,
        onClick: this._onClick,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onKeyDown: this.props.onKeyDown
      });
    }
  }]);
  return SearchInput;
}(_react.BaseComponent);

exports.SearchInput = SearchInput;